<!-- Header Views -->
<app-header></app-header>
<!-- Header Views -->
<!-- Content Views -->
<main id="main-component">
  <div>
    <router-outlet></router-outlet>
  </div>
</main>
<!--/. Content Views -->
